const localDateKey = date => [
  date.getFullYear(),
  String(date.getMonth() + 1).padStart(2, '0'),
  String(date.getDate()).padStart(2, '0')
].join('-');

export const createPublicReminderFilters = (now = new Date()) => {
  const end = new Date(now);
  end.setDate(end.getDate() + 4);
  return {
    startDate: localDateKey(now),
    endDate: localDateKey(end),
    tipo: '',
    urgenza: '',
    email: '',
    assignedEmail: '',
    studio: [],
    fatto: 'da fare',
    da: ''
  };
};

export const getReminderDateRange = filters => {
  if (!filters?.startDate || !filters?.endDate) return null;
  const parseLocalDate = value => {
    const [year, month, day] = value.split('-').map(Number);
    return new Date(year, month - 1, day);
  };
  const start = parseLocalDate(filters.startDate);
  const end = parseLocalDate(filters.endDate);
  end.setHours(23, 59, 59, 999);
  return { start, end };
};
